import { SxProps } from '@mui/material';

// Above the modal (1500); !important beats the popper's inline zIndex.
const popper: SxProps = {
  zIndex: '1501 !important'
};

export const teamPickerFieldSx = {
  popper
};
